import { openShare } from '@/lib/share'
import { Directory, File, Paths, type DownloadOptions } from 'expo-file-system'

function base64ToUint8Array(base64: string) {
  const binaryString = atob(base64)
  const len = binaryString.length
  const bytes = new Uint8Array(len)
  for (let i = 0; i < len; i++) {
    bytes[i] = binaryString.charCodeAt(i)
  }
  return bytes
}

export async function saveImageFromBase64(base64: string, filename: string, extension = 'png') {
  try {
    const file = new File(Paths.cache, `${filename}.${extension}`)
    if (!file.exists) {
      file.create()
    }
    file.write(base64ToUint8Array(base64.replace(/^data:image\/\w+;base64,/, '')))

    await openShare({
      url: file.uri,
      type: `image/${extension}`,
      failOnCancel: false,
    })
  } catch (error) {
    console.error(error)
  }
}

// A separator would put the file in another directory, and the rest are refused by some file systems
function safeFileName(name: string) {
  const safeName = name.replace(/[/\\:*?"<>|\x00-\x1f]/g, '_').trim()
  return safeName === '.' || safeName === '..' ? '' : safeName
}

/**
 * Without `fileName`, the file is named from the response: Android cannot read an RFC 5987 `filename*` in
 * Content-Disposition, and names it after the URL instead.
 */
export async function saveFileFromRemoteUrl(
  url: string,
  {
    fileName,
    download,
    onDownloaded,
  }: { fileName?: string; download?: DownloadOptions; onDownloaded?: () => void } = {}
) {
  const destination = new Directory(Paths.cache, 'files')
  if (!destination.exists) {
    destination.create()
  }

  const safeName = fileName ? safeFileName(fileName) : ''
  const output = await File.downloadFileAsync(url, safeName ? new File(destination, safeName) : destination, download)
  onDownloaded?.()
  await openShare({
    url: output.uri,
    failOnCancel: false,
  })
}
